module.exports = __webpack_public_path__ + "img/1 (109).28abbc40.png";